import React, { useEffect, useState } from 'react'
import './task.css'
import ButtonWrapper from '../../../widgets/button/button'
import ModalWrapper from '../../../widgets/modal/modal';
import AddTask from '../../../componant/addTask/addTask';
import AgGridContainer from '../../../componant/gridContainer/gridContainer';
import CustomDatePicker from '../../../widgets/datePicker/datePicker';
import { RefreshCellsParams } from 'ag-grid-community';
import { StatusModel } from '../../../model/status-model/status.model';
import AddStatusChangeReason from '../../../componant/addStatusChangeReason/addStatusChangeReason';
import ViewTaskReason from '../../../componant/viewTaskReason/viewTaskReason';
import { SnackbarService } from '../../../services/snackBehaviorSubject/snackBehaviorSubject';
import { updateDueDate, updateStatus } from '../../../api-services/employee-services';
import { TokenService } from '../../../services/token.service';
import FetchApi from '../../../fetch-api/fetch-api';
import { useSelector } from 'react-redux';
import { formateISODate } from '../../../util_service/dateFormater/dateFormater';
import { maxWidth } from '@mui/system';

interface statusProps {
    taskId: number,
    value: string,
    reason: string,
    uniqueId: number
}
interface completionProps {
    taskId: string,
    completionDate: string,
    reason: string,
    uniqueId: number
}

interface Status {
    id: number;
    value: string;
    reason: string | null;
    statusUpdateDate: string;
}

interface CompletionTarget {
    id: number;
    completionDate: string;
    reason: string | null;
}

interface TaskProps {
    id: number;
    employeeId: string;
    projectId: string;
    description: string;
    createdDate: string;
    uniqueId: number,
    status: Status[];
    completionTargets: CompletionTarget[];
}

interface UpdateStatus {
    taskId: number;
    value: string;
}

interface typeProps {
    type: string;
    field: string
}


const TaskList = () => {
    const task = useSelector((state: any) => state.task.userTask)
    const Token = TokenService.extractToken()
    const fetchApi = FetchApi()
    const snackbarService = SnackbarService()
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [rowData, setRowData] = useState<TaskProps[]>([])
    const [originalRowData, setOriginalRowData] = useState<TaskProps[]>([])
    const [rowParams, setRowParams] = useState<any[]>([])
    const [updateButtonDisable, setUpdateButtonDisable] = useState<boolean>(true)
    const [status, setStatus] = useState<statusProps[]>([])
    const [completion, setCompletion] = useState<completionProps[]>([])
    const [openReasonModal, setOpenReasonModal] = useState<boolean>(false);
    const [isSatusChange, setIsStatusChange] = useState<boolean>(false)
    const [isViewReason, setisViewReason] = useState<boolean>(false)
    const [reasonDetails, setReasonDetails] = useState<string>('')
    const [selectedRow, setSelectedRow] = useState<any[]>([])
    const [changeDetaction, setChangeDetection] = useState<any[]>([])
    const [type, setType] = useState<typeProps>()
    const handleOpenReasonModal = () => {
        setOpenReasonModal(true)
    };
    const handleCloseReasonModal = () => {
        setOpenReasonModal(false);
        setisViewReason(false)
    }

    const fetchData = () => {
        if (Token)
            fetchApi.getUserTask(Token.sub)
    }

    useEffect(() => {
        fetchData()
    }, [])

    useEffect(() => {
        if (task.length > 0) {
            setRowData(JSON.parse(JSON.stringify(task)))
            setOriginalRowData(JSON.parse(JSON.stringify(task)))
        }
    }, [task])

    const statusOption = [
        { name: 'Pending', value: 'PENDING', disable: true },
        { name: 'In Progress', value: 'IN_PROGRESS', disable: false },
        { name: 'On Hold', value: 'ON_HOLD', disable: false },
        { name: 'Completed', value: 'COMPLETED', disable: false },
        { name: 'Discarded', value: 'DISCARDED', disable: false },
    ]

    const findStatusChange = (updateStatus: UpdateStatus[], updateCompletion: any[]) => {


        const newArray: any[] = [];
        if (originalRowData)
            originalRowData.forEach((element: any) => {
                updateStatus.forEach((ele: any) => {
                    if (element.id === ele.taskId) {
                        if (element.status[0].value !== ele.value) {
                            newArray.push(element.id);
                        } else {
                            const index = newArray.indexOf(element.id);
                            if (index !== -1) {
                                newArray.splice(index, 1);
                            }

                        }
                    }
                })

                updateCompletion.forEach((ele: any) => {
                    if (element.id === ele.taskId) {
                        if (element.completionTargets[0].completionDate !== ele.completionDate) {
                            newArray.push(element.id)
                        } else {
                            const index = newArray.indexOf(element.id);
                            if (index !== -1) {
                                newArray.splice(index, 1);
                            }
                        }
                    }
                })

            })

        return newArray;



    }

    useEffect(() => {

        const isButtonDisable = findStatusChange(status, completion)
        if (isButtonDisable.length > 0) {
            setUpdateButtonDisable(false)
        } else {
            setUpdateButtonDisable(true)
        }

    }, [completion, status])


    const onStatusChange = (event: React.ChangeEvent<HTMLSelectElement>, params: { node: any; api: any; data: any }) => {
        console.log(params, "Paramssssssssssssssssssssssssssssssssssssss")
        setType({ type: 'single', field: 'status' })
        const newValue = event.target.value;
        const taskId = params.data.id;
        const uniqueId = params.data.uniqueId;
        const description = params.data.description;
        const previousStatus = params.node.data.status[0].value
        setIsStatusChange(true)
        params.node.data.status[0].value = newValue
        let p: RefreshCellsParams = {
            force: true,
            rowNodes: [params.node],
        };
        params.api.refreshCells(p)

        console.log(rowData, "Row Data")

        const matchTask = originalRowData.find((t: any) => t.id === taskId)

        if (matchTask) {
            const currentStatus = matchTask.status[0].value
            if (currentStatus !== newValue) {
                setStatus((prevStatus: any) => {
                    const existingIndex = prevStatus.findIndex((s: { taskId: any; }) => s.taskId === taskId);

                    if (existingIndex >= 0) {
                        const updatedStatus = prevStatus.map((s: any, index: any) =>
                            index === existingIndex ? { ...s, value: newValue } : s
                        );
                        return updatedStatus;
                    }

                    return [...prevStatus, { taskId, uniqueId, value: newValue }];
                });

                params.node.data.status[0].reason = matchTask.status[0].reason
                let p: RefreshCellsParams = {
                    force: true,
                    rowNodes: [params.node],
                };
                params.api.refreshCells(p)

                if (!selectedRow.includes(taskId)) {
                    setSelectedRow([...selectedRow, taskId]);
                }
                handleOpenReasonModal()
                setRowParams((preav: any) => {
                    return [...preav, params]
                })

                setChangeDetection(prevState => {
                    const existingTask = prevState.find(task => task.taskId === taskId);
                    const previousCompletion = existingTask ? existingTask.completion : undefined;

                    return [
                        ...prevState,
                        {
                            taskId: taskId,
                            task: newValue,
                            uniqueId: uniqueId,
                            description: description,
                            previousStatus: previousStatus,
                            status: { placeholder: 'status change', name: 'status' },
                            completion: previousCompletion !== undefined ? previousCompletion : undefined
                        }
                    ];
                });

            } else {
                params.node.data.status[0].reason = matchTask.status[0].reason
                let p: RefreshCellsParams = {
                    force: true,
                    rowNodes: [params.node],
                };
                params.api.refreshCells(p)
                setStatus(prevStatus => prevStatus.filter(s => s.taskId !== taskId));
                setSelectedRow(selectedRow.filter(item => item !== taskId));
                setChangeDetection(prevState => {
                    const taskIndex = prevState.findIndex((task: any) => task.taskId === taskId);
                    if (taskIndex >= 0 && prevState[taskIndex].completion === undefined) {
                        return prevState.filter((task: any) => task.taskId !== taskId);
                    }
                    return prevState;
                });
                handleCloseReasonModal()
            }
        }




    };

    const handleChangeReason = (reason: any) => {
        reason.forEach((item: any) => {
            if (item.status !== undefined) {
                setStatus(prevStatus => {
                    const updatedStatus = prevStatus.map(s => {
                        if (s.taskId === item.taskId) {
                            return {
                                ...s,
                                reason: item.status.value,
                            };
                        }
                        return s;
                    });
                    return updatedStatus;
                });
            }

            if (item.completion !== undefined) {
                setCompletion(prevCompletion => {
                    const updateCompletion = prevCompletion.map(c => {
                        if (c.taskId === item.taskId) {
                            return {
                                ...c,
                                reason: item.completion.value,
                            };
                        }
                        return c
                    })
                    return updateCompletion
                })
            }
        });

        setChangeDetection(reason)

    }

    const handleDateChange = (value: any, name: any, params: any) => {
        console.log(params, "Paramssssssssssssssssssssssssssssss")
        setType({ type: 'single', field: 'completion' })
        const taskId = params.data.id;
        const uniqueId = params.data.uniqueId;
        const presentDate = value;
        const description = params.data.description;
        const previousDate = params.node.data.completionTargets[0].completionDate
        setIsStatusChange(false)


        params.node.data.completionTargets[0].completionDate = value
        let p: RefreshCellsParams = {
            force: true,
            rowNodes: [params.node],
        };
        params.api.refreshCells(p)

        const matchTask = originalRowData.find((e: any) => e.id === taskId)
        if (matchTask) {
            const currentDate = matchTask.completionTargets[0].completionDate
            if (currentDate !== value) {
                setCompletion((preav: any[]) => {
                    const index = preav.findIndex(item => item.taskId === taskId);
                    if (index !== -1) {
                        return preav.map((item, i) =>
                            i === index ? { ...item, completionDate: value, uniqueId: uniqueId } : item
                        );
                    } else {
                        return [...preav, { taskId: taskId, completionDate: value, uniqueId: uniqueId }];
                    }
                });
                params.node.data.completionTargets[0].reason = matchTask.completionTargets[0].reason
                let p: RefreshCellsParams = {
                    force: true,
                    rowNodes: [params.node],
                };
                params.api.refreshCells(p)
                handleOpenReasonModal()
                setRowParams((preav: any) => {
                    return [...preav, params]
                })
                if (!selectedRow.includes(taskId)) {
                    setSelectedRow([...selectedRow, taskId]);
                }



                setChangeDetection(prevState => {
                    const existingTaskIndex = prevState.findIndex(element => element.taskId === taskId);


                    if (existingTaskIndex !== -1) {
                        const updatedTasks = [...prevState];
                        updatedTasks[existingTaskIndex] = {
                            ...prevState[existingTaskIndex],
                            taskId: taskId,
                            uniqueId: uniqueId,
                            presentDate: presentDate,
                            previousDate: previousDate,
                            description: description,
                            completion: { placeholder: 'completion change', name: 'completion' }
                        };
                        return updatedTasks;
                    } else {
                        return [
                            ...prevState,
                            {
                                taskId: taskId,
                                uniqueId: uniqueId,
                                presentDate: presentDate,
                                previousDate: previousDate,
                                description: description,
                                completion: { placeholder: 'completion change', name: 'completion' }
                            }
                        ];
                    }
                });
            } else {
                setCompletion(prevStatus => prevStatus.filter(s => s.taskId !== taskId));
                handleCloseReasonModal()
                params.node.data.completionTargets[0].reason = matchTask.completionTargets[0].reason
                let p: RefreshCellsParams = {
                    force: true,
                    rowNodes: [params.node],
                };
                params.api.refreshCells(p)
                setChangeDetection(prevState => {
                    const taskIndex = prevState.findIndex((task: any) => task.taskId === taskId);
                    if (taskIndex >= 0 && prevState[taskIndex].status === undefined) {
                        return prevState.filter((task: any) => task.taskId !== taskId);
                    }
                    return prevState;
                });
                setSelectedRow(selectedRow.filter(item => item !== taskId));
            }

        }


    }

    useEffect(() => {
        changeDetaction.forEach(item => {

            if (item.status !== undefined) {
                setStatus(prevStatus => {
                    const updatedStatus = prevStatus.map(s => {
                        if (s.taskId === item.taskId) {
                            return {
                                ...s,
                                reason: item.status?.value,
                            };
                        }
                        return s;
                    });
                    return updatedStatus;
                });
            }

            if (item.completion !== undefined) {
                setCompletion(prevCompletion => {
                    const updatedCompletion = prevCompletion.map(c => {
                        if (c.taskId === item.taskId) {
                            return {
                                ...c,
                                reason: item.completion?.value,
                            };
                        }
                        return c;
                    });
                    return updatedCompletion;
                });
            }
        });

    }, [changeDetaction]);

    const onReasonView = (reason: string) => {
        handleOpenReasonModal()
        setisViewReason(true)
        setReasonDetails(reason)
    }


    const getMinDate = (date: any) => {
        const givenDate = new Date(date)
        givenDate.setHours(0, 0, 0, 0)
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        const minDate = givenDate > today ? givenDate : today;
        return minDate;

    }

    const colDefs = [
        {
            headerName: 'Id',
            field: 'uniqueId',
            width: 90
        },
        {
            headerName: 'Project Name',
            field: 'projectName',
        },
        {
            headerName: 'Task',
            field: 'description',
        },
        {
            headerName: 'Creation Date',
            field: 'createdDate',
            valueFormatter: (params: any) => {
                const value = formateISODate(params.value)
                return value
            }
        },
        {
            headerName: 'Start Date',
            field: 'startDate'
        },
        {
            headerName: 'Status',
            field: 'status',
            cellRenderer: (params: any) => {
                return <div className='reason-main-container'>
                    <select value={params?.data?.status[0].value} style={{ height: '20px' }} onChange={(e) => onStatusChange(e, params)}>
                        {statusOption.map((statusOption: any, index: number) => (
                            <option key={index} value={statusOption.value} disabled={statusOption.disable}>
                                {statusOption.name}
                            </option>
                        ))}
                    </select>
                </div>
            }
        },
        {
            headerName: 'Status Change Reason',
            field: 'status',
            cellRenderer: (params: any) => {
                console.log(params, "Paar")
                return <div className='reason-main-container' onClick={() => onReasonView(params.node.data.status[0].reason)}>
                    <div className='reason-container' >
                        <div className='single-line-text'  >{params?.node.data?.status[0].reason}</div>
                    </div>
                </div>
            }
        },
        {
            headerName: 'Due Date',
            field: 'completionDate',
            cellRenderer: (params: any) => {
                console.log(params, "Params.....")
                const selectedDate = { 'completionDate': (params?.data?.completionTargets.length > 0 ? params.data.completionTargets[0].completionDate : completion[0].completionDate) }
                return <div className='date-range-sub-container' style={{ height: '35px' }}>
                    <div className='completion-date-picker-container'>
                        <div className='date-sub-container'>
                            <CustomDatePicker selectedDate={selectedDate} handleDate={handleDateChange} name='completionDate' params={params} minDate={getMinDate(params.data.completionTargets[0].completionDate)} />
                        </div>
                    </div>
                </div>
            }
        },
        {
            headerName: 'Due Date Change Reason',
            field: 'completionDate',
            cellRenderer: (params: any) => {

                return <div className='reason-main-container' onClick={() => onReasonView(params.node.data.completionTargets[0].reason)}>

                    <div className='reason-container'>
                        <div className='single-line-text'  >{params.node.data.completionTargets[0].completionDate !== null ? params.node.data.completionTargets[0].reason : null}</div>
                    </div>
                </div>
            }
        }
    ]

    const handleClose = () => {
        setOpenModal(false)
    };
    const onCreateTask = () => {
        setOpenModal(true)
    }

    const handleUpdateTask = () => {
        let allReasonsProvided = true;
        setType({ type: 'multiple', field: '' })

        status.forEach(status => {
            if (status.value === StatusModel.ON_HOLD && (!status.hasOwnProperty("reason") || status.reason === "" || status.reason === undefined)) {
                snackbarService.next({ data: { open: true, severity: 'error', message: `Task with ID ${status.taskId} is ${status.value} but no reason is provided.` } })
                allReasonsProvided = false
                handleOpenReasonModal()
                setIsStatusChange(true)
            }
        })

        completion.forEach(comp => {
            if (comp.completionDate && (!comp.hasOwnProperty("reason") || comp.reason === '' || comp.reason === undefined)) {
                snackbarService.next({ data: { open: true, severity: 'error', message: `Task with ID ${comp.uniqueId} is completion date is changed but no reason is provided.` } })
                allReasonsProvided = false
                setIsStatusChange(false)
                handleOpenReasonModal()
            }
        })

        if (allReasonsProvided) {
            if (status.length === 0 && completion.length > 0) {
                updateDueDate(completion).then((response: any) => {
                    if (response.data.success) {
                        snackbarService.next({ data: { open: true, severity: 'success', message: response.data.message } })
                        setUpdateButtonDisable(true)
                        setSelectedRow([])
                        setCompletion([])
                        setChangeDetection([])
                    } else {
                        snackbarService.next({ data: { open: true, severity: 'error', message: response.data.message } })
                    }
                    fetchData()
                })
            } else if (status.length > 0 && completion.length === 0) {
                updateStatus(status).then((response: any) => {
                    if (response.data.success) {
                        setUpdateButtonDisable(true)
                        setStatus([])
                        setSelectedRow([])
                        setChangeDetection([])
                        snackbarService.next({ data: { open: true, severity: 'success', message: response.data.message } })
                    } else {
                        snackbarService.next({ data: { open: true, severity: 'error', message: response.data.message } })
                    }
                    fetchData()
                })
            } else if (status.length > 0 && completion.length > 0) {
                Promise.all([
                    updateDueDate(completion),
                    updateStatus(status)
                ])
                    .then(responses => Promise.all(responses.map(response => {
                        return response
                    })))
                    .then(data => {
                        snackbarService.next({ data: { open: true, severity: 'success', message: 'Status and Due date is updated' } })
                        setUpdateButtonDisable(true)
                        setSelectedRow([])
                        setStatus([])
                        setCompletion([])
                        setChangeDetection([])
                    })
                    .catch(error => console.error('Error:', error));
                fetchData()
            } else {
            }
        }
    }




    return (
        <div className="main">
            <div className="main-container">
                <div className="heading heading-center-space-between height-40">
                    <h2>Task List</h2>
                    <div className='flex-end-center'>
                        <ButtonWrapper buttonType='circle' className='circular-add-button' onClick={onCreateTask} tooltipPlacement='left' tooltipTitle='Create Task' />
                    </div>
                    <ModalWrapper open={openModal} close={handleClose} children={<AddTask onClose={handleClose} title='Create Task' />} />
                </div>
                <div className="cal-40">
                    <div className='task-container'>
                        <div className='task-sub-ag-grid-container'>
                            <AgGridContainer rowData={rowData} columnDefs={colDefs} />
                        </div>
                        <div className='task-update-button-container'>
                            <ButtonWrapper title='Update' id='submit-button' variant='contained' type='submit' onClick={handleUpdateTask} disable={updateButtonDisable} showCount={selectedRow && selectedRow.length > 0 ? selectedRow.length : 0} />
                        </div>
                    </div>
                </div>
                <ModalWrapper open={openReasonModal} close={handleCloseReasonModal} children={!isViewReason ? <AddStatusChangeReason onClose={handleCloseReasonModal} params={rowParams} changeDetection={changeDetaction} handleChangeStatusReason={handleChangeReason} isStatusChange={isSatusChange} type={type} /> : <ViewTaskReason reason={reasonDetails} onClose={handleCloseReasonModal} />} />
            </div>
        </div>

    )
}

export default TaskList
